import { Typography } from '@material-ui/core';
import { pad } from 'app/Core/Helpers';
import clsx from 'clsx';
import React from 'react';
import { useStopwatch } from 'react-timer-hook';

function MyTime({ className }) {
    const { seconds, minutes, hours } = useStopwatch({ autoStart: true });

    return (
        <Typography color="textSecondary" className={clsx("flex items-center", className)}>
            <span>{pad(hours)}</span>:<span>{pad(minutes)}</span>:<span>{pad(seconds)}</span>
        </Typography>
    );
}

const Cronometro = ({ className }) => {
    return (
        <React.Fragment>
            <MyTime className={className} />
        </React.Fragment>
    );
}

export default Cronometro;